import React, { Component } from 'react'
import Mask from './mask'
import css from './styleOutline.module.css'

export default class Text extends Component {
    state = {
        error: null
    }

    setError(error) {
        this.setState({
            error
        })
    }

    removeError() {
        this.setState({
            error: null
        })
    }

    componentDidMount() {
        if(this.props.onChangeDOM)
        this.refs.input.addEventListener('change', (event) => {
            this.props.onChangeDOM(event)
        })
    }
    
    render() {
        const { style, label, TrailingIcon, className, onChangeDOM, ...props } = this.props

        const classes = [className]

        classes.push(css.box)

        if(TrailingIcon)
        classes.push(css.withTrailingIcon)

        return (
            <label className={classes.join(' ')} style={{ ...style }}>
                <input
                    ref="input"
                    {...props}
                    placeholder=" "
                    className={[css.formControl, this.state.error !== null ? css.error : null].join(' ')}
                    onKeyUp={this.props.mask ? (e) => Mask(e, this.props.mask, (e) => {
                        if(this.props.onChange)
                            this.props.onChange(e)
                    }) : null}
                    onKeyPress={() => {
                        this.removeError()
                    }} />
                {label && (
                    <span>{label}</span>
                )}
                {TrailingIcon && (
                    <span className={css.trailingIcon}>
                        <TrailingIcon />
                    </span>
                )}
                {this.state.error && (
                    <span className={css.errorMessage}>{this.state.error}</span>
                )}
            </label>
        )
    }
}


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/Form/Text.js